export default () => ({
  organizations: [],
  activeOrganization: {}
})
